import { Observable } from "rxjs";
import { ThirdPartyLoginCredentials } from "@app/core/user/domain/third-party-login-credentials";
import { LoginResponse } from "@app/core/user/domain/login.reponse";

/**
 * This service is used to login with a third party provider (Google, Facebook, Apple)
 */
export abstract class ThirdPartyLoginService {
  abstract execute(
    credentials: ThirdPartyLoginCredentials
  ): Observable<LoginResponse>;
}
